import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default class StoryboardChapterLabel extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    fontSize: PropTypes.string,
    text: PropTypes.string,
  };

  static defaultProps = {
    fontSize: '',
    text: '',
    textColor: '',
  };

  render() {
    return (
      <div
        className={'StoryboardChapterLabel'}
        style={{
          color: this.props.color,
          fontSize: this.props.fontSize,
        }}>
        {this.props.text}
      </div>
    );
  }
}
